/* eslint-disable */
import * as React from "react";
import { SlideContext } from "../Context";
import { ComponentSourcetitle } from '../../../components/ComponentSourcetitle';
import { ComponentPreloader } from '../../../components/ComponentPreloader';
import { useChartForecastData } from '../data/useChartForecastData';
import { useHighchartForecastTransformer } from '../transformers/useHighchartForecastTransformer';
import { useHookSubscribe } from "../../../shared/hooks/hookSubscribe";
import HighchartsChart from '../../../../charts/components/HighchartsChart';
import { ComponentContextReadyState } from "@sa/rep-core";
import { ComponentTitle } from "../../../components/ComponentTitle";
import { ComponentFootnote } from "../../../components/ComponentFootnote";
import { useExportSource } from '../hooks/useExportSource';
import { useForecastFootnote } from '../hooks/useForecastFootnote';

export const ComponentChartForecast: React.FC<{ context: SlideContext }> = (props) => {
  const context = props.context;
  const olapResult = useHookSubscribe(null, context.olapResultForecast$);
  const source = useHookSubscribe(null, context.sourcesForecast$);
  const loading = useHookSubscribe(null, context.loading$);

  const chartData = useChartForecastData(olapResult);
  const highchartData = useHighchartForecastTransformer(chartData);
  const footnote = useForecastFootnote();

  if (window['exportMode']) {
    window["exportReady"] = !loading;
  }

  if (loading) {
    return <ComponentPreloader />;
  }
  return <>
    <ComponentTitle>Short term forecast prices</ComponentTitle>
    <ComponentSourcetitle>Source: Forecast - {source || 'CBOT'}</ComponentSourcetitle>
    <HighchartsChart data={highchartData} loader={<ComponentPreloader />} />
    <ComponentFootnote>{footnote}</ComponentFootnote>
  </>
};
